// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__3Ot0n","name":"style_name__3kWSs"};